// Libraries
var React = require('react');
var cloneDeep = require('lodash/cloneDeep');
var utilGuid = require('../../common/utilGuid.js');
var moment = require('moment');

// Components
var ListingCardsModule = require('../ListingCards/ListingCards');
var HeadlineModule = require('../Headline/Headline');
var MultiSelectModule = require('../MultiSelect/MultiSelect');
var PaginationModule = require('../Pagination/Pagination');
var Icon = require('../../common/Icon/Icon.js');

// Style
require('./ListingCardFilters.scss');
require('../Filters/Filters.scss');
require('../NoResults/NoResults.scss');

class ListingCardFiltersModule extends React.Component {
  constructor(props) {

    super(props);

    this.resultsTop = React.createRef(); 

    const cardsPerPage = 9;
    const cardCount = this.props.data.cardData.cards.length;

    const pages = this.calculatePages(cardCount, cardsPerPage);

    let cardData = cloneDeep(this.props.data.cardData);
    cardData.cards = cardData.cards.slice(0, cardsPerPage);

    this.state = {
      cardData: cardData,
      cardDataResults: this.props.data.cardData.cards,
      subcategorySet: this.props.data.subcategorySets.default,
      subcategoryOptions: this.getAllSubcategoryOptions(),
      category: '',
      subcategory: '',
      seatingArea: '',
      seatingType: '',
      refinements: this.props.data.months ? this.props.data.months.map((month)=> {
        month.selected = false;
        return month;
      }) : [],
      page: 1,
      pages: pages,
      cardsPerPage: cardsPerPage,
      order: 'lowToHigh',
      interacted: false,
      filtering: false,
      showFiltersMobile: false
    }

  }

  setCardData() {

    let cardData = cloneDeep(this.props.data.cardData);
    
    const category = this.state.category;
    const subcategory = this.state.subcategory;
    const refinements = this.state.refinements;
    const refinementsSelected = this.calculateRefinementsSelected(refinements);
    
    const filtering =
    ((this.state.category !== '') ||
    (this.state.subcategory !== '') ||
    (this.state.order !== 'lowToHigh') ||
    refinementsSelected) ? true : false;

    let cards = [];

    {cardData.cards.map((item) => {

      let hidden = (category !== '') && (item.categories.indexOf(category) < 0);
      hidden = ((subcategory !== '') && (item.subcategories.indexOf(subcategory) < 0)) ? true : hidden;

      if (refinementsSelected) {
        hidden = !this.isRefinementSelected(refinements, item.fixture ? moment(item.fixture.kickOff).format('yyyy-MM') : '') ? true : hidden;
      }

      if (!hidden) cards.push(item);

    })}

    // SP-764 - remove sort order selection for now
    //if (this.state.order === 'lowToHigh') {
    //  cards.sort((a,b) => a.price - b.price)
    //} else {
    //  cards.sort((a,b) => b.price - a.price);
    //}

    this.setState({ cardDataResults: cards });

    let sliceStart = this.state.page - 1;
    if (sliceStart !== 0) { sliceStart = (this.state.cardsPerPage * sliceStart); }
    let sliceEnd = sliceStart + this.state.cardsPerPage;

    const pages = this.calculatePages(cards.length, this.state.cardsPerPage);

    cardData.cards = cards.slice(sliceStart, sliceEnd);

    this.setState({ cardData: cardData, interacted: true, pages: pages, filtering: filtering });

  }

  calculatePages(numberOfCards, cardsPerPage) {

    return Math.ceil((numberOfCards / cardsPerPage));

  }

  isRefinementSelected(refinements, refinement) {

    let selected = false;

    for (let i = 0; i < refinements.length; i++) {

      const currentRefinment = refinements[i];

      if(currentRefinment.selected && !currentRefinment.value) {
        return true;
      }
      
      if (currentRefinment.value === refinement) {
        selected = currentRefinment.selected;
        break;
      }
    
    }

    return selected;

  }

  getAllSubcategoryOptions() {
    return this.props.data.subcategorySets.items[this.props.data.subcategorySets.default].length ? this.props.data.subcategorySets.items[this.props.data.subcategorySets.default] : this.props.data.subcategorySets.items[this.props.data.subcategorySets.default];
  }

  calculateRefinementsSelected(refinements) {

    let count = 0;
    for (let i = 0; i < refinements.length; i++) { if (refinements[i].selected) { count++; } }
    return count;

  }

  handleSubcategoryChange(event) {

    this.setState({ subcategory: event.target.value, page: 1 }, function() {
      this.setCardData();
    });

  }

  // SP-764 - remove sort order selection for now
  //handleSortChange(event) {
  //  this.setState({ order: event.target.value, page: 1 }, function() {
  //    this.setCardData();
  //  });
  //}

  handleClearClick() {

    let refinements = cloneDeep(this.state.refinements);
    for (let i = 0; i < refinements.length; i++) { refinements[i].selected = false; }

    this.setState({
        category: '',
        subcategory: '',
        page: 1,
        order: 'lowToHigh',
        subcategorySet: this.props.data.subcategorySets.default,
        subcategoryOptions: this.getAllSubcategoryOptions(),
        seatingArea: '',
        seatingType: '',
        refinements: refinements
    }, function () {
      this.setCardData();
    });

  }

  getSubcategoryBasedOnRefinement(refinements) {

   let selectedRefinements = [];
   for (let index = 0; index < refinements.length; index++) {
     var currentRefinment = refinements[index];

     if(currentRefinment.selected) {
       selectedRefinements.push(currentRefinment.value);
     }
      
   }

   const allSubcategoryOptions = this.getAllSubcategoryOptions();
   if(!selectedRefinements.length || selectedRefinements.indexOf('') !== -1) {
    return allSubcategoryOptions;
   }

   let filteredSubcategoryOptions = [allSubcategoryOptions[0]];
   for (let index = 0; index < allSubcategoryOptions.length; index++) {
    const currentOption = allSubcategoryOptions[index];
    if(!currentOption.value) {
      continue;
    }
    const currentOptionMonth = moment(currentOption.kickOff).format('yyyy-MM');
    if(selectedRefinements.indexOf(currentOptionMonth) !== -1) {
      filteredSubcategoryOptions.push(currentOption);
    }
   }
   return filteredSubcategoryOptions;

  }

  handleRefinementChange(index) {

    let refinements = cloneDeep(this.state.refinements);
    refinements[index].selected = !refinements[index].selected;

    const subcategoryOptions = this.getSubcategoryBasedOnRefinement(refinements);

    this.setState({ refinements: refinements, page: 1, subcategoryOptions: subcategoryOptions, subcategory: '' }, function() {
      this.setCardData();
    });

  }

  handlePaginationChange(page) {

    this.setState({ page: page }, function() {
      this.setCardData();
      this.resultsTop.current.scrollIntoView();
    });

  }

  getPaginationData() {

    return {
      page: this.state.page,
      pages: this.state.pages
    };

  }

  handleToggleFiltersDisplay() {

    this.setState({
      showFiltersMobile: !this.state.showFiltersMobile
    });

  }

  getResultsText() {

		if (!this.state.cardData.cards.length) {
      return (
        <div className="c-filters__secondary__control c-filters__secondary__control--summary">
          <p className="c-filters__summary">Showing <strong>0</strong> of <strong>0</strong> results</p>
        </div>
      );
		}

		const displayStart = Math.max(0, ((this.state.page - 1) * this.state.cardsPerPage) + 1);
		const displayEnd = Math.min(this.state.cardDataResults.length, this.state.cardsPerPage * this.state.page);
    const display = (displayStart === displayEnd) ? displayStart : `${displayStart} - ${displayEnd}`;

    return (
      <div className="c-filters__secondary__control c-filters__secondary__control--summary">
        <p role={`${this.state.interacted ? "status" : ""}`} className="c-filters__summary">Showing <strong>{display}</strong> of <strong>{this.state.cardDataResults.length}</strong> results</p>
      </div>
    );

	}

  render() {
    const subcategorySelectId = 'listing-card-filters-subcategory-' + utilGuid.guid();
    // SP-764 - remove sort order selection for now
    //const orderSelectId = 'listing-card-filters-order-' + utilGuid.guid();
    return (
      <div id={this.props.data.id}>
        <HeadlineModule data={this.props.data}>
          <div className="c-headline__extra">
            <div className="c-headline__extra__inner">
            
              <div className={`c-filters  ${this.props.data.isPremium ? " c-filters--premium" : ""}`}>

                <button type="button" className={`c-filters__toggle ${this.state.showFiltersMobile ? 'is-open' : ''}`} onClick={this.handleToggleFiltersDisplay.bind(this)}>
                  <Icon name="filters" width={25.246} height={23.502} className="c-filters__toggle-icon c-filters__toggle-icon--filters" />
                  <span className="c-filters__toggle__text">{this.state.showFiltersMobile ? 'Hide ' : 'Show'} filters</span>
                  <Icon name="chevronRightAlt" width={23.996} height={14.897} className="c-filters__toggle-icon c-filters__toggle-icon--arrow" />
                </button>
                

                <div className={`c-filters__primary${this.state.showFiltersMobile ? ' is-open' : ''}${this.state.filtering ? ' c-filters__primary--filtering' : ''}`}>
                  <div className="c-filters__primary__inner">

                    <div className="c-filters__primary__control">
                      <label className="c-filters__label js-multi-select-label">Month</label>
                      <MultiSelectModule data={this.state.refinements} parentCallback={this.handleRefinementChange.bind(this)} noneSelectedText="Any" selectedOptionsText="month" />
                    </div>
                    
                    <div className="c-filters__primary__control c-filters__primary__control--subcategory">
                      <label htmlFor={subcategorySelectId} className="c-filters__label">Matchday</label>
                      <select onChange={this.handleSubcategoryChange.bind(this)} className="c-filters__select" value={this.state.subcategory} id={subcategorySelectId} disabled={this.props.data.subcategorySets.items[this.state.subcategorySet].length ? null : true}>
                        {this.state.subcategoryOptions.map((item, index) => {
                          return(
                            <option key={index} value={item.value}>{item.text}</option>
                          );
                        })}
                      </select>
                    </div>

                    {this.state.filtering &&
                      <div className="c-filters__primary__control c-filters__primary__control--clear">
                        <button type="button" className="c-filters__clear-button" onClick={this.handleClearClick.bind(this)}>Clear all filters</button>
                      </div>
                    }
                  
                  </div>
                </div>

                <div className="c-filters__secondary" ref={this.resultsTop}>

                  {this.getResultsText()}
                  
                  {(this.state.pages > 1) &&
                    <div className="c-filters__secondary__control c-filters__secondary__control--pagination">
                      <PaginationModule data={this.getPaginationData()} parentCallback={this.handlePaginationChange.bind(this)} />
                    </div>
                  }

                  {/* SP-764 - remove sort order selection for now */}
                  {/*<div className="c-filters__secondary__control c-filters__secondary__control--sort">*/}
                  {/*  <label htmlFor={orderSelectId} className="u-visually-hidden">Sort by</label>*/}
                  {/*  <select onChange={this.handleSortChange.bind(this)} className="c-filters__select c-filters__select--small" value={this.state.order} id={orderSelectId}>*/}
                  {/*    <option value="lowToHigh">Price (low to high)</option>*/}
                  {/*    <option value="highToLow">Price (high to low)</option>*/}
                  {/*  </select>*/}
                  {/*</div>*/}

                </div> 

              </div>

            </div>
          </div>
        </HeadlineModule>
        <ListingCardsModule data={this.state.cardData} />
        {!this.state.cardData.cards.length &&
          <div id={this.props.data.id} className={`c-section c-section--tight-top${this.props.data.isPremium ? " c-section--premium" : ""}`}>
            <div className="c-section__inner">
              <p className="c-no-results" role="status">No results found for your selection.</p>
            </div>
          </div>
        }
        {(this.state.pages > 1) &&
          <div className="c-section c-section--tight-top c-section--center">
            <div className="c-section__inner">
              <PaginationModule data={this.getPaginationData()} parentCallback={this.handlePaginationChange.bind(this)} />
            </div>
          </div>
        }
      </div>
    );
  }
};

module.exports = ListingCardFiltersModule;


// WEBPACK FOOTER //
// ./src/components/ListingCardFilters/ListingCardFilters.js